import { Button, Modal } from "@material-ui/core";
import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import Loadspinner from "../../../common/Loadspinner";
import Main from "../../../common/Main/Main";
import CommonService from "../../../services/CommonService";
import CreateKnowledgeService from "../../../services/CreateKnowledgeService";

import VideoRecorder from "react-video-recorder";
import "./CreateKnowledge.css";
import { Recorder } from "react-voice-recorder";
import "react-voice-recorder/dist/index.css";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

/* import Swal from "sweetalert2"; */
import { toast } from "react-toastify";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../../firebase";
import CommonConstants from "../../../constants/CommonConstants";

function CircularProgressWithLabel(props) {
  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress variant="determinate" {...props} />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          variant="caption"
          component="div"
          style={{ fontSize: "20px", color: "white", marginLeft: "70%" }}
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

CircularProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

class CreateKnowledge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      system: true,
      divisionList: [],
      platformList: [],
      systemList: [],
      subSystemList: [],
      divisionId: 1,
      platformId: 0,
      systemId: 0,
      subSystemId: 0,
      isLoading: false,
      attachment: null,
      title: "",
      description: "",
      tags: "",
      success: false,
      recordedVideo: {},
      isRecorded: false,
      video: {},
      fileName: "",
      audioRecName: "",
      videoRecName: "",
      isProgress: false,
      progressStatus: "",
      audioDetails: {
        url: null,
        blob: null,
        chunks: null,
        duration: { h: null, m: null, s: null },
      },
      audio: {},
      isAudio: false,
      firstToken: "",
      videoId: "",
      thumbnailId: "",
      transcriptionData: [],
      videoToken: "",
    };
  }

  componentDidMount() {
    this.getDivision();
    this.getPlatform();
    this.getToken();
    this.getSystem();
  }

  //division
  getDivision = async () => {
    this.setState({ isLoading: true });
    const res = await CommonService.getDivisionList();

    if (res) {
      this.setState({ divisionList: res });
    }
    this.setState({ isLoading: false });
  };

  setDivision = (e) => {
    this.getPlatform();
    this.getSystem();
    this.setState({ divisionId: e.target.value });
  };

  //platform

  getPlatform = async () => {
    let { divisionId } = this.state;
    this.setState({ isLoading: true });
    const res = await CommonService.getPlatformList(divisionId);
    if (res) {
      this.setState({ platformList: res });
    }
  };

  setPlatform = (e) => {
    this.setState({ platformId: e.target.value });
  };

  //system

  getSystem = async () => {
    let { divisionId } = this.state;
    const res = await CommonService.getSystemList(divisionId);
    if (res) {
      this.setState({ systemList: res });
    }
    this.setState({ isLoading: false });
  };

  setSystem = (e) => {
    this.setState({ systemId: e.target.value });
    if (e.target.value > 0) {
      this.setState({ system: false });
    }

    this.getSubsystem(e.target.value);
  };

  //subsystem

  getSubsystem = async (systemId) => {
    this.setState({ isLoading: true });
    const res = await CommonService.getSubSystemList(systemId);
    if (res) {
      let idList = res;
      idList.map((item) => (item.isSelected = false));
      this.setState({ subSystemList: idList });
    }

    this.setState({ isLoading: false });
  };
  setSubsystem = (e) => {
    this.setState({ subSystemId: e.target.value });
  };

  setUnchecked = (id) => {
    const subsystemLists = this.state.subSystemList;

    subsystemLists.map((item) =>
      item.id == id ? (item.isSelected = !item.isSelected) : null
    );
    this.setState({ subsystemList: subsystemLists });
  };

  //title

  setTitle = (e) => {
    this.setState({ title: e.target.value });
  };

  //description

  setDescription = (e) => {
    this.setState({ description: e.target.value });
  };

  //tags

  addTags = () => {
    let selectedIdList = [];

    this.state.subSystemList.map((item) =>
      item.isSelected ? selectedIdList.push(item.subsystem_desc) : null
    );

    this.setState({ tags: selectedIdList });
  };

  //attachment

  fileSelect = (e) => {
    let { type } = e.target.files[0];
    let strarray = type.split("/");
    let strng = strarray[0];
    if (strng == "video") {
      this.uploadVideoTrans(e.target.files[0]);
    } else {
      this.setState({ attachment: e.target.files[0] });
    }
    this.setState({ fileName: e.target.files[0].name });

    this.setState({ isRecorded: false });
  };

  //video
  setRecordedVideo = async () => {
    this.setState({ isRecorded: true });
    this.setState({ isAudio: false });
    let blob = this.state.recordedVideo.slice(
      0,
      this.state.recordedVideo.size,
      "video/webm"
    );
    let timestamp = Date.now();
    let newFile = new File([blob], `video${timestamp}.webm`, {
      type: "video/webm",
    });
    this.setState({ video: newFile });
    this.setState({ videoRecName: newFile.name });
    this.uploadVideoTrans(newFile);
  };

  uploadVideoTrans = async (newFile) => {
    let { firstToken } = this.state;
    this.setState({ isLoading: true });

    const knowledgeData = new FormData();
    knowledgeData.append("", newFile);

    let resp = await CreateKnowledgeService.uploadVideo(
      firstToken,
      knowledgeData
    );
    if (resp) {
      let { id } = resp;
      this.setState({ videoId: id });
      this.getDetails(firstToken, id);
    } else {
     /*  Swal.fire({
        text: "An error occurred while uploading the video file. Please try again later.",
        toast: true,
      }); */
      toast("An error occurred while uploading the video file. Please try again later.")
    }
    this.setState({ isLoading: false });
  };

  getDetails = async (firstToken, id) => {
    this.setState({ isProgress: true });
    let resp = await CreateKnowledgeService.getVideoDetails(firstToken, id);

    if (resp.results[0].processingProgress != "100%") {
      setTimeout(() => (resp = this.getDetails(firstToken, id)), 3000);
      let status = parseInt(resp.results[0].processingProgress);
      this.setState({ progressStatus: status });
    } else {
      this.setState({ thumbnailId: resp.results[0].thumbnailId });

      this.getVideoToken();
      this.getTranscriptionData();
    }
  };

  getVideoToken = async () => {
    let { videoId } = this.state;
    let res = await CreateKnowledgeService.getVideoToken(videoId);
    if (res) {
      this.setState({ videoToken: res });
    }
  };

  getTranscriptionData = async () => {
    let { videoId, videoToken } = this.state;
    let res = await CreateKnowledgeService.getTranscription(
      videoId,
      videoToken
    );
    if (res) {
      let data = {
        transcript: res.videos[0].insights.transcript,
      };
      let transcript = JSON.stringify(data);
      this.setState({ transcriptionData: transcript });
    }
    this.setState({ isProgress: false });
  };

  //token

  getToken = async () => {
    const res = await CreateKnowledgeService.firstApi();
    if (res) {
      this.setState({ firstToken: res });
    }
  };

  //audio

  handleAudioStop = (data) => {
    this.setState({ audioDetails: data });
  };
  handleAudioUpload = (file) => {
    this.setState({ isRecorded: true });
    let blob = file.slice(0, file.size, "audio/webm");
    let timestamp = Date.now();
    let newFile = new File([blob], `audio${timestamp}.webm`, {
      type: "audio/webm",
    });
    this.setState({ audio: newFile });
    this.setState({ audioRecName: newFile.name });
  };

  setRecordedAudio = () => {
    let { isRecorded } = this.state;

    if (isRecorded) {
      this.setState({ isAudio: true });
    } else {
      alert("Please upload audio to proceed");
    }
  };

  handleRest = () => {
    const reset = {
      url: null,
      blob: null,
      chunks: null,
      duration: {
        h: null,
        m: null,
        s: null,
      },
    };
    this.setState({ audioDetails: reset });
  };

  createKnowledge = async (e) => {
    e.preventDefault();
    const {
      title,
      description,
      divisionId,
      platformId,
      systemId,
      subSystemId,
      attachment,
      // video,
      audio,
      isAudio,
      isRecorded,
      videoId,
      thumbnailId,
      transcriptionData,
    } = this.state;

    const knowledgeData = new FormData();

    knowledgeData.append("title", title);
    knowledgeData.append("description", description);
    //knowledgeData.append("tag", tags);
    knowledgeData.append("division_id", divisionId);
    knowledgeData.append("platform_id", platformId);
    knowledgeData.append("system_id", systemId);
    knowledgeData.append("subsystem_id", subSystemId);
    knowledgeData.append("video_id", videoId);
    knowledgeData.append("transcription_data", transcriptionData);
    knowledgeData.append("thumbnailId", thumbnailId);
    isRecorded
      ? isAudio
        ? knowledgeData.append("attachment", audio)
        : // : knowledgeData.append("attachment", video)
        null
      : knowledgeData.append("attachment", attachment);

    this.setState({ isLoading: true });

    const res = await CreateKnowledgeService.createKnowledge(knowledgeData);
    if (res) {
      this.setState({ isLoading: false });
      this.setState({ success: true });
    } else {
      alert("Added Successfully");
    }
    // //logEvent(analytics(), "submitMediaRecorder");

    this.setState({ isLoading: false });
    this.setState({ isRecorded: false });
  };

  render() {
    const {
      system,
      divisionList,
      divisionId,
      platformList,
      systemList,
      subSystemList,
      isLoading,
      title,
      description,
      success,
      fileName,
      isRecorded,
      isAudio,
      isProgress,
      audioRecName,
      videoRecName,
      progressStatus,
    } = this.state;
    if (success) {
      return <Redirect to="/home" />;
    }
    return (
      <Main active="create_knowledge">
        <Loadspinner filename="CreateKnowledge.js" isLoading={isLoading} isMiddle="false" />
        <Modal
          disablePortal
          disableEnforceFocus
          disableAutoFocus
          open={isProgress}
          style={{ background: "transparent" }}
        >
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
            }}
          >
            <CircularProgressWithLabel
              value={progressStatus}
              style={{ width: "100px" }}
            />
            <p style={{ margin: "25px", color: "white" }}>Uploading Video</p>
          </div>
        </Modal>

        <div className="container ">
          <h5>Create Knowledge</h5>
          <div className="card create-knowledge-card">
            <div className="row card-row">
              <div className="col-6 ">
                <label
                  className="form-check-label"
                  style={{ marginRight: "20px" }}
                >
                  Division
                </label>
                {divisionList.map((division) => (
                  <div
                    className="form-check form-check-inline "
                    key={division.id}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      value={division.id}
                      checked={divisionId == division.id ? true : false}
                      onChange={this.setDivision}
                      autoComplete={CommonConstants.autoCompleteInput}
                    />
                    <label className="form-check-label ">
                      {division.division_desc}
                    </label>
                  </div>
                ))}
              </div>
              <div className="col-6">
                <select
                  className="form-select"
                  required
                  onChange={this.setPlatform}
                >
                  <option value="" disabled selected>
                    Platform
                  </option>
                  {platformList.map((platform) => (
                    <option key={platform.id} value={platform.id}>
                      {platform.platform_desc}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row card-row">
              <div className="col-6">
                <select
                  className="form-select"
                  required
                  onChange={this.setSystem}
                >
                  <option value="" disabled selected>
                    CoE
                  </option>
                  {systemList.map((system) => (
                    <option key={system.id} value={system.id}>
                      {system.system_desc}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-6">
                <select
                  className="form-select "
                  disabled={system}
                  onChange={this.setSubsystem}
                  required
                >
                  <option value="" disabled selected>
                    SubCoE
                  </option>
                  {subSystemList.map((subSystem) => (
                    <option key={subSystem.id} value={subSystem.id}>
                      {subSystem.subsystem_desc}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="row card-row">
              <div className="col-12">
                <textarea
                  className="form-control"
                  name="title"
                  onChange={this.setTitle}
                  value={title}
                  rows="2"
                  placeholder="Title"
                  required
                />
              </div>
            </div>
            <div className="row card-row">
              <div className="col-12">
                <textarea
                  className="form-control"
                  onChange={this.setDescription}
                  name="description"
                  value={description}
                  id="exampleFormControlTextarea1"
                  rows="6"
                  placeholder="Detailed description"
                  required
                />
              </div>
            </div>
            {/* <div className="row card-row display-row">
              <div className="col-2">
                <button
                  className="btn btn-primary"
                  disabled={system}
                  data-bs-toggle="modal"
                  data-bs-target="#addTagsck"
                >
                  Add tags
                </button>
              </div>
              <div
                className="modal fade"
                id="addTagsck"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                aria-labelledby="addExpertiseLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-sm">
                  <div
                    className="modal-content"
                    style={{ borderRadius: "10px" }}
                  >
                    <div className="modal-header">
                      <h5 className="modal-title ">Add tags</h5>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body">
                      {subSystemList.map((system) => (
                        <div key={system.id}>
                          <input
                            type="checkbox"
                            className="form-check-input popup-checkbox"
                            onChange={() => this.setUnchecked(system.id)}
                          />
                          <label className="form-check-label">
                            {system.subsystem_desc}
                          </label>
                        </div>
                      ))}
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-primary"
                        data-bs-dismiss="modal"
                        onClick={this.addTags}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-10 display-row">
                {tags.length > 0
                  ? tags.map((tag, index) => (
                      <div className="card" key={index}>
                        <small>{tag}</small>
                      </div>
                    ))
                  : null}
              </div>
            </div> */}
            <div className="row card-row">
              <div className="col-3">
                <input
                  style={{ display: "none" }}
                  id="contained-button-file"
                  type="file"
                  onChange={this.fileSelect}
                  autoComplete={CommonConstants.autoCompleteInput}
                />
                <label
                  htmlFor="contained-button-file"
                  style={{ width: "100%" }}
                >
                  <Button
                    variant="contained"
                    component="span"
                    onClick={() => {
                      this.fileUpload;
                    }}
                    style={{
                      width: "100%",
                      backgroundColor: "#198754",
                      color: "white",
                    }}
                    disabled={isLoading}
                  >
                    Upload
                  </Button>
                  {isRecorded ? null : <span>{fileName}</span>}
                </label>
              </div>
              <div className="col-3">
                <button
                  type="button"
                  className="btn btn-success"
                  data-bs-toggle="modal"
                  style={{ width: "100%" }}
                  data-bs-target="#record"
                  disabled={isLoading}
                >
                  Record
                </button>
                {isRecorded ? (
                  isAudio ? (
                    <span>{audioRecName} </span>
                  ) : (
                    <span>{videoRecName} </span>
                  )
                ) : null}

                <div
                  className="modal fade"
                  id="record"
                  data-bs-backdrop="static"
                  data-bs-keyboard="false"
                  tabIndex="-1"
                  aria-labelledby="staticBackdropLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h6>Select mode of recording</h6>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body justify-space-around">
                        <button
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target="#record-audio"
                          className="btn btn-success col-4"
                          data-bs-dismiss="modal"
                        >
                          Audio
                        </button>
                        <button
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target="#record-video"
                          className="btn btn-success col-4"
                          data-bs-dismiss="modal"
                        >
                          Video
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* modal for audio */}
                <div
                  className="modal fade"
                  id="record-audio"
                  data-bs-backdrop="static"
                  data-bs-keyboard="false"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Record audio</h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body">
                        <Recorder
                          record={true}
                          title={"New recording"}
                          audioURL={this.state.audioDetails.url}
                          showUIAudio
                          handleAudioStop={(data) => this.handleAudioStop(data)}
                          handleOnChange={(value) =>
                            this.handleOnChange(value, "firstname")
                          }
                          handleAudioUpload={(data) =>
                            this.handleAudioUpload(data)
                          }
                          handleRest={() => this.handleRest()}
                        />
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>

                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={this.setRecordedAudio}
                          data-bs-dismiss="modal"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* modal for video */}
                <div
                  className="modal fade"
                  id="record-video"
                  data-bs-backdrop="static"
                  data-bs-keyboard="false"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="staticBackdropLabel">
                          Record video
                        </h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body">
                        <VideoRecorder
                          showReplayControls
                          timeLimit={30000}
                          isOnInitially
                          onRecordingComplete={(videoBlob) => {
                            this.setState({ recordedVideo: videoBlob });
                          }}
                        />
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>

                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={this.setRecordedVideo}
                          data-bs-dismiss="modal"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-3">
                <Link to="/home">
                  <button
                    className="btn btn-danger"
                    disabled={isLoading}
                    style={{ width: "100%" }}
                  >
                    Cancel
                  </button>
                </Link>
              </div>
              <div className="col-3">
                <button
                  className="btn btn-danger"
                  style={{ width: "100%" }}
                  type="submit"
                  onClick={this.createKnowledge}
                  disabled={isLoading}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </Main>
    );
  }
}

export default CreateKnowledge;
